import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook para acceder al tier y límites del usuario actual.
 * Cachea en memoria. Refresca con refresh().
 */
export const useSubscription = () => {
  const [data, setData] = useState({ tier: null, subscription: null, loading: true });

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/subscriptions/me`);
      setData({ tier: r.data.tier, subscription: r.data.subscription, loading: false });
    } catch (e) {
      setData({ tier: { key: 'free', limits: {} }, subscription: null, loading: false });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const can = (feature) => Boolean(data.tier?.limits?.[feature]);
  const isPro = () => ['client_pro_month','client_pro_year','client_family_month','client_family_year'].includes(data.subscription?.tier_key);
  const isFree = () => !data.subscription?.tier_key || data.subscription?.tier_key === 'free';

  return { ...data, can, isPro, isFree, refresh };
};
